"use client";

import { Col, Container, Row } from "react-bootstrap";
import "./AIResultsSection.scss";
import Image from "next/image";
import { useState } from "react";
import Button from "@/components/Button/Button";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";

const AIResultsSection = ({ result }) => {
  const [showModal, setShowModal] = useState(false);
  const handleClick = () => {
    setShowModal(true);
  };

  if (!result) return null;

  const { title, description, resultData = [] } = result;

  return (
    <section className="ai-results-section">
      <Container>
        <div className="results-box">
          <Row className="align-items-center">
            {/* Left Content */}
            <Col xxl={5} xl={5} lg={5}>
              <div className="results-content">
                <h2 className="results-title">{title}</h2>

                <p className="results-description">{description}</p>
                <div className="text-left">
                  <Button
                    variant="primary"
                    size="lg"
                    className="action-btn"
                    onClick={handleClick}
                  >
                    Talk With Us
                  </Button>
                </div>
              </div>
            </Col>

            {/* Right Cards */}
            <Col xxl={7} xl={7} lg={7}>
              <div className="results-grid">
                {resultData.map(({ icon, title }, index) => (
                  <div className="result-card" key={index}>
                    <div className="result-icon">
                      <Image src={icon} alt={title} width={36} height={36} />
                    </div>

                    <h5 className="result-title">{title}</h5>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          
        </div>
      </Container>
      <ContactFormModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => setShowModal(false)}
      />
    </section>
  );
};

export default AIResultsSection;
